module.exports = __webpack_public_path__ + "media/images/niq-sort-asc-c24f4c6a6a2577c84f5ebfb7f9dd683d.svg";